import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-step-by-step',
  templateUrl: './step-by-step.component.html',
  styleUrls: ['./step-by-step.component.scss']
})
export class StepByStepComponent implements OnInit, OnChanges {

  @Input() index = 0;
  @Input() steps = [];
  @Input() touchedIndex = 0;
  @Output() indexChange = new EventEmitter();
  @Output() touchedIndexChange = new EventEmitter();


  constructor() {}

  ngOnInit() {
  }

  ngOnChanges() {
    this.change(this.index);
  }

  private stepClick(index) {
    this.change(index);
  }

  change(index) {
    let nextIndex = this.validateStep(index);
    let nextTouchedIndex = this.touchedIndex < nextIndex ? nextIndex : this.touchedIndex;
    if( nextIndex != this.index ) {
      this.indexChange.emit(nextIndex);
    }
    if(nextTouchedIndex != this.touchedIndex) {
      this.touchedIndex = nextTouchedIndex;
      this.touchedIndexChange.emit(nextTouchedIndex);
    }
  }

  validateStep(i) {
    let stepIndex = parseInt(i);
    if(stepIndex === NaN) {
      return 0;
    }
    if(stepIndex >= 0 && stepIndex <= this.steps.length){
      return stepIndex;
    } 
    return 0;
  }

}
